var colors = require('lxui/config/colors');
function set16ToRgb(val) {
    var reg = /^#([\da-fA-f]{3}|[\da-fA-f]{6})$/;
    var colorName = val.toLowerCase();
    var result = '';
    if (reg.test(colorName)) {
        if (colorName.length === 4) {
            var colorNew = '#';
            for (var i = 1; i < 4; i += 1) {
                colorNew += colorName.slice(i, i + 1).concat(colorName.slice(i, i + 1));
            }
            colorName = colorNew;
        }
        var colorChange = [];
        for (var i = 1; i < 7; i += 2) {
            colorChange.push(parseInt("0x".concat(colorName.slice(i, i + 2)), 16));
        }
        result = "".concat(colorChange.join(','));
        return result;
    }
    return '';
}
export var lxColors = {
    orange: colors.orange,
    blue: colors.blue,
};
var changeTheme = function (color, extendColor, name) {
    var id = "lxui-theme".concat(name ? "-".concat(name) : '');
    var changeThemeColor = function (list) {
        var themeLink = document.getElementById(id);
        themeLink === null || themeLink === void 0 ? void 0 : themeLink.remove();
        themeLink = document.createElement('style');
        themeLink.setAttribute('type', 'text/css');
        themeLink.setAttribute('id', id);
        themeLink.setAttribute('theme', color);
        document.head.appendChild(themeLink);
        var inner = '';
        for (var i = 0; i < list.length; i += 1) {
            inner += "".concat(list[i].key, ":").concat(list[i].value, ";");
        }
        inner = ":root{".concat(inner, "}");
        themeLink.innerText = inner;
    };
    var themeObj = {};
    Object.keys(lxColors).forEach(function (theme) {
        themeObj[theme] = [];
        Object.keys(lxColors[theme]).forEach(function (item) {
            themeObj[theme].push({
                key: "--lxy-primary-".concat(item),
                value: set16ToRgb(lxColors[theme][item]),
            });
        });
    });
    if (Object.keys(lxColors).includes(color)) {
        if (extendColor) {
            Object.keys(extendColor).forEach(function (theme) {
                Object.keys(extendColor[theme]).forEach(function (item) {
                    themeObj[theme].push({
                        key: "--lxy-primary-".concat(item),
                        value: set16ToRgb(extendColor[theme][item]),
                    });
                });
            });
        }
        changeThemeColor(themeObj[color]);
    }
};
export default changeTheme;
